import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { QuestionAuthorization } from '@models/votes/question-authorization.entity';
import { Question } from '@models/votes/question.entity';
import { UserAnswer } from '@models/votes/user-answer.entity';
import { VoteResult } from '@models/votes/vote-result.dto';
import { Vote } from '@models/votes/vote.entity';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  constructor(private http: HttpClient) {}

  getVoteList() {
    return this.http.get<Question[]>(environment.host + '/vote/list');
  }

  getQuestionList() {
    return this.http.get<Question[]>(environment.host + '/admin/vote/list');
  }

  createQuestion(questions: Question[]) {
    return this.http.get<VoteResult[]>(environment.host + '/question/create');
  }

  assignAuthorizedUsersToQuestion(
    questionId: number,
    questAuths: QuestionAuthorization[],
  ) {
    return this.http.post(
      environment.host + '/question/assign/' + questionId,
      questAuths,
    );
  }

  modifyQuestion(questions: Question[]) {
    return this.http.post(environment.host + '/question/modify', questions);
  }

  remveQuestion(questions: Question[]) {
    return this.http.post(environment.host + '/question/remove', questions);
  }

  getEncryptedVote(questionId: number): Observable<Vote[]> {
    return this.http.get<Vote[]>(
      environment.host + '/vote/user-answer/' + questionId,
    );
  }

  getEncryptedVotes(): Observable<UserAnswer[]> {
    return this.http.get<UserAnswer[]>(environment.host + '/vote/all-answer/');
  }

  sendVote(questionId: number, votes: Vote[]) {
    return this.http.post(environment.host + '/vote/send/' + questionId, votes);
  }
}
